import React from "react";
import {
  Add as AddIcon,
  CalendarMonthOutlined as CalendarIcon,
} from "@mui/icons-material";

import Button, { ButtonTypes } from "../../../../../../components/Button";
import { NoScheduleVariantProps } from "./types";
import {
  EmptyHeader,
  EmptyIcon,
  EmptyTitle,
  EmptyBody,
  ButtonWrapper,
} from "./styles";

export const NoScheduleVariant: React.FC<NoScheduleVariantProps> = ({
  onEditLiability,
  onLogPayment,
}) => (
  <>
    <EmptyHeader>
      <EmptyIcon>
        <CalendarIcon />
      </EmptyIcon>
      <EmptyTitle>No payment schedule set</EmptyTitle>
    </EmptyHeader>
    <EmptyBody>
      Add a payment frequency and due day to track what&apos;s coming up next.
    </EmptyBody>
    <ButtonWrapper>
      <Button
        type={ButtonTypes.primary}
        size="large"
        buttonType="button"
        onClick={onEditLiability}
      >
        <AddIcon />
        Add payment details
      </Button>
    </ButtonWrapper>
    <Button
      type={ButtonTypes.link}
      buttonType="button"
      underline
      tone="secondary"
      onClick={onLogPayment}
      data-testid="liability-log-anyway"
    >
      Log a payment anyway
    </Button>
  </>
);
